import { createStore, combineReducers, applyMiddleware, compose  } from 'redux';
import thunk from 'redux-thunk';
import projectsReducer from './ProjectsReducer';
import usersReducer from './UsersReducer';
import appInfoReducer from './AppInfoReducer';
import functionsReducer from './FunctionsReducer';
import actionsReducerV2 from './ActionsReducerV2';
import procedureManualReducer from './ProcedureManualReducer';
import proceduresReducer from './ProceduresReducer';
import projectSpecificProceduresReducer from './ProceduresReducer';

const rootReducer = combineReducers({
  projects : projectsReducer,
  users : usersReducer,
  app : appInfoReducer,
  functions : functionsReducer,
  procedureManual : procedureManualReducer,
  procedures : proceduresReducer,
  actions : actionsReducerV2, 
})

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


export const store = createStore(rootReducer,composeEnhancer(applyMiddleware(thunk)));
